/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const capacityPerformanceEnumsCapacityAndPerformanceFaultTypeOptionEnum = {
    Overload: 'Overload',
    UpdateFailure: 'UpdateFailure',
    Offline: 'Offline',
    Other: 'Other',
} as const;

export type CapacityPerformanceEnumsCapacityAndPerformanceFaultTypeOptionEnumKey =
    (typeof capacityPerformanceEnumsCapacityAndPerformanceFaultTypeOptionEnum)[keyof typeof capacityPerformanceEnumsCapacityAndPerformanceFaultTypeOptionEnum];

export type CapacityPerformanceEnumsCapacityAndPerformanceFaultTypeOption =
    CapacityPerformanceEnumsCapacityAndPerformanceFaultTypeOptionEnumKey;
